import type { NormalComponents } from 'react-markdown/lib/complex-types';
import styled from 'styled-components';

import { CodeBlock } from './codeblock';

const Cursor = styled.span`
  margin-top: 2px;
  cursor: default;
`;

export const p: NormalComponents['p'] = ({ children }) => {
  return <p>{children}</p>;
};

export const a: NormalComponents['a'] = ({ href, children }) => {
  return (
    <a href={href} target="_blank" rel="noreferrer">
      {children}
    </a>
  );
};

export const code: NormalComponents['code'] = ({
  node,
  // @ts-ignore
  inline,
  className,
  children,
  ...props
}) => {
  if (children.length) {
    if (children[0] == '▍') {
      return <Cursor className="animate-pulse">▍</Cursor>;
    }

    children[0] = (children[0] as string).replace('`▍`', '▍');
  }

  const match = /language-(\w+)/.exec(className || '');

  if (inline) {
    return (
      <code className={className} {...props}>
        {children}
      </code>
    );
  }

  return (
    <CodeBlock
      key={Math.random()}
      language={(match && match[1]) || ''}
      value={String(children).replace(/\n$/, '')}
      {...props}
    />
  );
};
